import React                   from 'react';
import Logos                   from './components/logos';
import Koteret                 from './components/koteret';
import Form                    from './components/form';
import SignInButton            from './components/sign_in_button';
import LangSelector            from './components/langSelector';
import loginImage              from './images/loginImage.jpg';
import loginImageSmall         from './images/loginImageSmall.jpg';

import { words }               from './utils/dictionary';
import { badCredentialsAlert,
/*cleanLocalStorage */}   from './utils';



import { makeStyles }          from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        transition:      'opacity 0.8s',
    },
    container: {
        width:              '100vw',
        height:             '100vh',
        backgroundRepeat:   'no-repeat',
        backgroundPosition: 'center'
    }
}))

const Root: React.FC = () => {

  const classes = useStyles();

  const [size, setSize] = React.useState([0,0]);

  React.useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const wideScreen = React.useMemo(() => {
     return size[0] > 900 && size[1] > 650
  },[size])

  const [lang, setLang] = React.useState('heb')

  React.useEffect(() => {
    badCredentialsAlert(`${ words['badCredentials'][lang] }`);
    //cleanLocalStorage();
    localStorage.clear();
  },[lang])


  return (
    <div className = { classes.root }>
        <div
           className = { classes.container }
           style     = {{
               backgroundImage: `url(${ wideScreen ? loginImage : size[0] > 550 ? loginImageSmall : 'none' })`,
               backgroundSize:  wideScreen ? 'contain' : 'cover',
           }}
        >
        {
            !wideScreen
            &&
            <Logos size = { size } />
        }
        <Koteret
            wideScreen = { wideScreen }
            lang       = { lang }
        />
        <SignInButton
            wideScreen = { wideScreen }
            lang       = { lang }
        />
        <Form
           size       = { size }
           wideScreen = { wideScreen }
           lang       = { lang }
        />
        <LangSelector
            lang    = { lang }
            setLang = { setLang }
        />
        </div>
    </div>
  );
}



export default Root;



/**
 *
        "homepage": "https://www.yisumatica.org.il/flash-upload/pisa",

 */
